import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-step-item",
  templateUrl: "./step-item.component.html",
})
export class StepItemComponent {
  @Input() step: any;
  @Input() isCurrentSlide: boolean;
  @Output() nextClick: EventEmitter<any> = new EventEmitter();
  @Output() previousClick: EventEmitter<any> = new EventEmitter();

  handlePrevious() {
    this.previousClick.emit();
  }

  handleNext() {
    this.nextClick.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/step-item/step-item.component.ts